// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import building02Icon from "@/assets/icons/building-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Building02IconProps = Omit<IconProps, "name">;

export function Building02Icon(props: Building02IconProps): React.ReactNode {
  return <Icon name={building02Icon} {...props} />;
}
